var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mb-3 pa-2",attrs:{"value":true,"dismissible":"","color":"primary","icon":"check_circle"}},[_vm._v(_vm._s(_vm.groups.length)+" "+_vm._s(_vm.$t('PartsResults.Labels.ItemsFound')))])
}
var staticRenderFns = []

export { render, staticRenderFns }